import React from "react";
import styles from "./Checkbox.module.css";

interface CheckboxProps {
  text: string;
}
const Checkbox: React.FC<CheckboxProps> = ({ text }) => {
  return (
    <>
      <label className={styles["remember-me-label"]}>
        <input type="checkbox" className={styles["remember-me-checkbox"]} />
        <span className={styles["remember-me-text"]}>{text}</span>
      </label>
    </>
  );
};

export default Checkbox;
